import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        background: "#f9f9f9",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <header
        style={{
          background: "#004080",
          color: "#fff",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <h1>Altruist Technology Pvt. Ltd.</h1>
        <p>Privacy Policy</p>
      </header>

      {/* Main Content */}
      <main
        style={{
          maxWidth: "900px",
          margin: "30px auto",
          background: "#fff",
          padding: "25px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          lineHeight: "1.7",
          color: "#333",
        }}
      >
        <p>
          <strong>Effective Date:</strong> 16-Sep-2025
          <br />
          <strong>Last Updated:</strong>16-Sep-2025
        </p>

        <p>
          At Altruist Technology Pvt. Ltd. (“we,” “our,” or “us”), your privacy
          is important to us. This Privacy Policy explains how we collect, use,
          share, and protect your personal information when you use our
          websites, mobile applications, digital platforms, and related services
          (collectively, the “Services”).
        </p>

        <p>
          By accessing or using our Services, you agree to the practices
          described in this Privacy Policy.
        </p>

        <h2 style={{ color: "#004080" }}>1. Information We Collect</h2>
        <ul>
          <li>
            <strong>Personal Information:</strong> Name, email, phone, company,
            designation, etc.
          </li>
          <li>
            <strong>Account & Usage Data:</strong> Login credentials,
            preferences, activity logs.
          </li>
          <li>
            <strong>Technical Information:</strong> IP address, browser, OS,
            device IDs, analytics.
          </li>
          <li>
            <strong>Location Data:</strong> GPS or approximate location (if
            enabled).
          </li>
          <li>
            <strong>Communication Data:</strong> Feedback, queries, or messages.
          </li>
        </ul>

        <h2 style={{ color: "#004080" }}>2. How We Use Information</h2>
        <ul>
          <li>Provide, operate, and improve our Services.</li>
          <li>Ensure secure access and authenticate accounts.</li>
          <li>Personalize user experience and deliver features.</li>
          <li>Analyze usage trends, system performance, and reporting.</li>
          <li>Communicate updates, support, or inquiries.</li>
          <li>Comply with legal and regulatory requirements.</li>
        </ul>

        <h2 style={{ color: "#004080" }}>3. Sharing of Information</h2>
        <ul>
          <li>
            <strong>Service Providers:</strong> Trusted vendors and IT providers
            who support our Services.
          </li>
          <li>
            <strong>Legal & Compliance:</strong> Government or law enforcement
            authorities if required.
          </li>
          <li>
            <strong>Business Transfers:</strong> In mergers, acquisitions, or
            restructuring.
          </li>
        </ul>

        <h2 style={{ color: "#004080" }}>4. Data Security</h2>
        <ul>
          <li>Encrypted data transmission and secure storage.</li>
          <li>Restricted role-based access.</li>
          <li>Firewalls, monitoring, and intrusion detection systems.</li>
          <li>Employee training on safe data handling.</li>
        </ul>

        <h2 style={{ color: "#004080" }}>5. Data Retention</h2>
        <p>
          We retain information as long as necessary for Services, legal, or
          contractual obligations. Data is securely deleted or anonymized when
          no longer needed.
        </p>

        <h2 style={{ color: "#004080" }}>6. Your Rights</h2>
        <ul>
          <li>Access, correct, or update personal data.</li>
          <li>Request deletion of personal data (subject to obligations).</li>
          <li>Restrict or object to certain types of processing.</li>
          <li>Withdraw consent where applicable.</li>
        </ul>

        <h2 style={{ color: "#004080" }}>7. Cookies & Tracking</h2>
        <p>
          We use cookies to enhance experience, analyze usage trends, and
          personalize content. Cookies can be disabled in browser settings,
          though some features may not work properly.
        </p>

        <h2 style={{ color: "#004080" }}>8. Third-Party Links</h2>
        <p>
          Our Services may contain links to third-party platforms. We are not
          responsible for their privacy practices.
        </p>

        <h2 style={{ color: "#004080" }}>9. Updates to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Revisions will be
          posted with an updated “Last Updated” date.
        </p>

        <h2 style={{ color: "#004080" }}>10. Contact Us</h2>
        <p>
          <strong>Corporate Office:</strong> Plot No. 2, Sector-22, HSIIDC IT
          Park, Panchkula, Haryana – 134109, India
          <br />
          <strong>Registered Office:</strong> 4th Floor, Altruist Mount, Behind
          Hotel Firhill, Near Tunnel No. 103, Shimla, Himachal Pradesh – 171004,
          India
          <br />
          <strong>Email:</strong> sales@altruistindia.com | hr@altruistindia.com
          <br />
          <strong>Phone:</strong> +91 172-2970008
        </p>
      </main>

      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          fontSize: "14px",
          padding: "15px",
          background: "#f0f0f0",
        }}
      >
        &copy; {new Date().getFullYear()} Altruist Technology Pvt. Ltd. All
        rights reserved.
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
